module.exports = __webpack_public_path__ + "static/img/1.d4ba6dea.png";